import React from 'react';
import UploadComponent from './index';
import { Upload, Icon, message } from 'antd';
class PreviewUploadComponent extends UploadComponent {
  static getDerivedStateFromProps(nextProps) {
    // Should be a controlled component.
    if ('value' in nextProps) {
      return {
        ...(nextProps.value || {})
      };
    }
    return null;
  }
  constructor() {
    super();
    this.state = {
      fileUrl: ''
    };

    this.uploadOptions = {
      ...this.uploadOptions,
      listType: 'picture-card',
      showUploadList: false,
      onChange: this.handleChange
    };
  }

  handleChange = info => {
    this.uploadChange(info).then(url => {
      this.setState({ fileUrl: url });
      this.inputHandleChange({ fileUrl: url });
    });
  };
  inputHandleChange(value) {
    this.triggerChange(value);
  }
  triggerChange = changedValue => {
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(Object.assign({}, this.state, changedValue));
    }
  };
  render() {
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">上传缩略图</div>
      </div>
    );
    const imageUrl = this.state.fileUrl || this.state.imageUrl;
    return (
      <div>
        <Upload {...this.uploadOptions}>
          {imageUrl ? (
            <img src={imageUrl} style={{ width: 140 }} alt="preview_img" />
          ) : (
            uploadButton
          )}
        </Upload>
        <input
          type="hidden"
          value={this.state.fileUrl}
          onChange={this.inputHandleChange}
        />
      </div>
    );
  }
}

export default PreviewUploadComponent;
